import routerOptions0 from "/vercel/path0/app/router.options.ts";
import routerOptions1 from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}